export const READ = 'READ';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';

export const COMPANY_UPDATE_SERVICE_NOTES = 'COMPANY_UPDATE_SERVICE_NOTES';
